<div class="te-col-center" style="padding:0px;">

    <h2 mat-dialog-title>{{'Country' | translate}}</h2>

    <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{'Country' | translate}}</mat-label>
        <mat-select [(value)]="selectedCountry">
            <mat-option *ngFor="let country of countries" [value]="country">{{ country }}</mat-option>
        </mat-select>
    </mat-form-field>

    <mat-dialog-actions style="align-self: flex-end; justify-content: flex-end;" class="te-row-full te-vert-spacer">
        <div class="te-form-350 te-row-end">
            <button mat-raised-button (click)="selectCountry()" [disabled]="!selectedCountry" class="te-button-gray te-left-spacer" mat-dialog-close>{{'CrossBtnTxt' | translate}}</button>
        </div>
    </mat-dialog-actions>
</div>



